import React from "react";

const AppFooter = () => {
  const footerLinks = [
    { label: "Terms and Conditions", href: "/terms" },
    { label: "Refund Policy", href: "/refund" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Privacy Notice", href: "/privacy-notice" },
    { label: "Disclaimer", href: "/disclaimer" },
    { label: "Services", href: "/services" },
    { label: "Master Privacy Policy", href: "/master_privacy" },
    { label: "Consent Policy", href: "/consent_policy" },
    { label: "Medical Disclaimer", href: "/medical_disclaimer" },
    { label: "AI Disclaimer", href: "/AI_disclaimer" },
    { label: "Cookie Policy", href: "/cookie_policy" },
    { label: "Data Retention Policy", href: "/Data_retention_policy" },
    { label: "Regulatory Disclaimer", href: "/regulatory_disclaimer" },
    { label: "User Manual", href: "/user_manual" },
    { label: "Contact Us", href: "/contact" },
  ];

  return (
    <footer className="w-full px-4 pb-6 mt-10">
      <div className="max-w-7xl mx-auto bg-white/80 backdrop-blur-lg border border-gray-200 shadow-xl rounded-3xl p-5">

        {/* Brand */}
        <div className="text-center mb-5">
          <p className="text-sm sm:text-base text-gray-700">
            Powered by{" "}
            <span className="font-bold text-blue-700">
              AICA
            </span>{" "}
            | Your Smart Health Assistant
          </p>
        </div>

        {/* Footer Links */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 text-[11px] sm:text-xs md:text-sm">
          {footerLinks.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="px-3 py-2 rounded-full bg-gray-100 text-gray-700 hover:bg-blue-600 hover:text-white transition-all duration-300 shadow-sm hover:shadow-md"
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-5 pt-3 border-t border-gray-200 text-center text-[11px] sm:text-xs text-gray-500">
          © {new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;